export default function AdvanceChapterBar() {
    return (
        <div className="flex items-center bg-gradient-ww-blue-button px-12">
            <div className="mr-4 shrink-0">
                <img
                    className="h-32 w-32"
                    src="/images/champion-badge@3x.png"
                    alt="champion-badge"
                    width={32}
                    height={32}
                />
            </div>
            <p className="font-set-sb13 text-white">Early access chapter for Champions</p>
        </div>
    );
}
